export default __webpack_public_path__ + "ab7aba4390cede0cc18b70f56d665ead.svg";